module.exports = __webpack_public_path__ + "img/numc_03.e11af7c6.png";